import { applyMiddleware, createStore, Middleware } from 'redux'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createEpicMiddleware } from 'redux-observable'
import { createRootReducer, RootActions, rootEpic, RootState } from './root'
import { errorToast } from '../components/controls/Toaster/Toaster'
import { MESSAGES } from '../constants/messages'

export const history = createBrowserHistory()

const catchMiddleware: Middleware = () => next => action => {
    try {
        return next(action)
    } catch (error) {
        console.warn(error)
        errorToast(MESSAGES.REDUCER_ERROR(action.type))
    }
}

const epicMiddleware = createEpicMiddleware<RootActions, RootActions, RootState>()

const composeEnhancers = composeWithDevTools({
    trace: true,
})

export const store = createStore(
    createRootReducer(history),
    composeEnhancers(applyMiddleware(catchMiddleware, epicMiddleware, routerMiddleware(history))),
)

epicMiddleware.run(rootEpic)